import { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await axios.post('https://whats-app.360websitedemo.com/api/login', {
        email,
        password,
      });
      localStorage.setItem('token', response.data.token);
      setEmail('');
      setPassword('');
      setError('');
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-lg sm:max-w-2xl lg:max-w-4xl flex flex-col lg:flex-row bg-white shadow-xl rounded-xl overflow-hidden">
        {/* Left Section: WhatsApp Sender Info */}
        <div className="w-full lg:w-1/2 bg-green-600 text-white p-6 sm:p-8 flex flex-col justify-center">
          <h1 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">WhatsApp Sender</h1>
          <p className="text-sm sm:text-base mb-4 sm:mb-6">Connect with your customers instantly</p>
          <div className="space-y-2 sm:space-y-3">
            <p className="text-green-100 text-sm sm:text-base flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Secure messaging platform
            </p>
            <p className="text-green-100 text-sm sm:text-base flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Fast and reliable
            </p>
          </div>
        </div>

        {/* Right Section: Sign-in Form */}
        <div className="w-full lg:w-1/2 p-6 sm:p-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 text-gray-800">Sign in to your account</h2>
          <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">Enter your credentials to access your account</p>
          {error && <p className="text-red-500 mb-4 text-sm sm:text-base">{error}</p>}
          <div className="space-y-4 sm:space-y-5">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                placeholder="you@example.com"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white p-3 sm:p-4 rounded-lg hover:bg-blue-700 transition duration-200 font-medium"
            >
              Sign in
            </button>
          </div>
          <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row justify-center gap-2 sm:gap-4 text-sm text-gray-600">
            <p>
              Don’t have an account?{' '}
              <Link to="/register" className="text-blue-600 hover:underline">Sign up</Link>
            </p>
            <p>
              <Link to="/forgot-password" className="text-blue-600 hover:underline">Forgot Password?</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;